import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { CustomerOrderListPage } from "@/screens/CustomerOrders/components/CustomerOrderListPage/CustomerOrderListPage"
import { CUSTOMER_ORDER_ACCESS_PERMISSIONS } from "@/screens/CustomerOrders/constants"
import { customerOrderSearchSchema } from "@/screens/CustomerOrders/schemas"

export const Route: AnyRoute = createFileRoute("/app/orders/")({
  validateSearch: zodValidator(customerOrderSearchSchema),
  component: () => (
    <PermissionContentWrapper permissions={CUSTOMER_ORDER_ACCESS_PERMISSIONS}>
      <CustomerOrderListPage />
    </PermissionContentWrapper>
  ),
})
